const HOUR_DURATION_MIN = 60;
const DAY_DURATION_MIN = 24 * HOUR_DURATION_MIN;

export const transformEndTimeChange = (startMinutes: number, newValueInMinutes: number) => {
  const newEndMinutes = newValueInMinutes <= startMinutes ? newValueInMinutes + DAY_DURATION_MIN : newValueInMinutes;

  return { startMinutes, endMinutes: newEndMinutes };
};

export const transformStartTimeChange = (endMinutes: number, startMinutes: number) => {
  if (startMinutes > endMinutes) {
    return { startMinutes, endMinutes: endMinutes + DAY_DURATION_MIN };
  }

  if (endMinutes > DAY_DURATION_MIN && endMinutes - startMinutes > DAY_DURATION_MIN) {
    return { startMinutes, endMinutes: endMinutes - DAY_DURATION_MIN };
  }

  return { startMinutes, endMinutes };
};

export const stringToMinutes = (time: string): number => {
  const [HH, mm] = time.split(':').map(v => parseInt(v, 10));
  return HH * HOUR_DURATION_MIN + mm;
};
